import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../../global';
import { environment } from '../../../environments/environment';
import { AscInfoRequest, AscInfoResponse, AscInfoTimesheet, AscInfoComment, AscInfoPersonal } from '../models/asc-info.model';

export interface AscInfoSavedData {
  userCode: string;
  // 旧形式との互換性のため（ロード時のみ使用）
  userCode1?: string;
  userCode2?: string;
  userCode3?: string;
  ascUq: string;
  personal: AscInfoPersonal | null;
  email2: string;
  timesheets: AscInfoTimesheet[];
  comments: AscInfoComment[];
  showingPastTimesheets: boolean;
  showingPastComments: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AscInfoService {
  private apiUrl = environment.useApiGateway
    ? `${environment.apiGatewayUrl}/ascinfo`
    : `${GlobalVariable.BASE_URL}/AscInfo`;
  private savedData: AscInfoSavedData | null = null;

  constructor(private http: HttpClient) { }

  getAscInfo(request: AscInfoRequest): Observable<AscInfoResponse> {
    let params = new HttpParams();
    
    if (request.userCode) {
      params = params.set('userCode', request.userCode);
    }
    if (request.userId) {
      params = params.set('userId', request.userId.toString());
    }

    return this.http.get<AscInfoResponse>(this.apiUrl, { params });
  }

  getTimesheets(userId: number, usePastData: boolean = false): Observable<AscInfoTimesheet[]> {
    let params = new HttpParams();
    if (usePastData) {
      params = params.set('usePastData', 'true');
    }
    
    return this.http.get<AscInfoTimesheet[]>(`${this.apiUrl}/timesheets/${userId}`, { params });
  }

  getComments(userId: number, usePastData: boolean = false): Observable<AscInfoComment[]> {
    let params = new HttpParams();
    if (usePastData) {
      params = params.set('usePastData', 'true');
    }
    
    return this.http.get<AscInfoComment[]>(`${this.apiUrl}/comments/${userId}`, { params });
  }

  resetPassword(userId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset-password`, { userId });
  }

  resetEmail(userId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset-email`, { userId });
  }

  updateUser(userId: number, userCode: string, email2: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/update-user`, { userId, userCode, email2 });
  }

  checkEmailExists(email: string, currentUserId: number): Observable<boolean> {
    let params = new HttpParams()
      .set('email', email)
      .set('currentUserId', currentUserId.toString());
    return this.http.get<boolean>(`${this.apiUrl}/check-email-exists`, { params });
  }

  sendReminder(userId: number, yearMonth: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/send-reminder`, { userId, yearMonth });
  }

  // データ保存
  saveData(data: AscInfoSavedData): void {
    this.savedData = data;
  }

  // データ取得
  getSavedData(): AscInfoSavedData | null {
    return this.savedData;
  }

  // データクリア
  clearData(): void {
    this.savedData = null;
  }
}
